<template>
    <div  @click="dateOff" class="wxSend sp3 wxNoscroll">
        <wxBack></wxBack>
        <div class="bgShow">
            <Row class="topMon">
                合计金额
                <div class="bigMoney">
                    {{all.total_price}}<span>元</span>
                </div>
            </Row>
            <Row style="margin-top: 12vw;">
                <Col span="6" class="leftName">
                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;期
                </Col>
                <Col span="17" offset="1">
                    <DatePicker  @on-change="dateOff" readonly @click.native.stop="dateOn" :open="openDate" class="dataPicker toHeight" type="month" format="yyyy年MM月" v-model="currentMonth"></DatePicker>
                </Col>
            </Row>
            <Row>
                <table class="tabel">
                    <tr>
                        <th>
                            餐次
                        </th>
                        <th>
                            数量
                        </th>
                        <th>
                            应收金额
                        </th>
                    </tr>
                    <tr>
                        <td>早餐</td>
                        <td>{{all.breakfast_count}}</td>
                        <td>{{all.breakfast_total_price}}</td>
                    </tr>
                    <tr>
                        <td>午餐</td>
                        <td>{{all.lunch_count}}</td>
                        <td>{{all.lunch_total_price}}</td>
                    </tr>
                    <tr>
                        <td>晚餐</td>
                        <td>{{all.dinner_count}}</td>
                        <td>{{all.dinner_total_price}}</td>
                    </tr>
                </table>
            </Row>
            <!--{{showIt}}-->
            <wxNav></wxNav>
        </div>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import wxBack from "../wxBack"
    import wxNav from "../wxNav"
    export default {
        props:["wxCode"],
        data () {
          return{
                openDate:false,
                userName : "",
                title: "个人报餐统计",
                all: {
                    breakfast_count: 0,
                    breakfast_price: 0,
                    breakfast_total_price: 0,
                    lunch_count: 0,
                    lunch_price: 0,
                    lunch_total_price: 0,
                    dinner_count: 0,
                    dinner_price: 0,
                    dinner_total_price: 0,
                    total_price: 0
                },
                currentMonth: "",
                showIt:{}
            }
        },
        components:{
            wxNav,
            wxBack
        },
        watch: {
            "currentMonth" (){
                this.getData();
            }
        },
        computed: {
		    ...mapState(["xcxId","xcxUser","xcxReal"]),
		},
        methods:{
            ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","SET_LOADING"]),
            dateOn(){
                this.openDate = true;
            },
            dateOff(){
                this.openDate = false;
            },
            // getPeople(){
            //     // let params = {};
            //     var that = this;
            //     // params.data = {
            //     //     searchValue: {
            //     //         "xcx_openId": this.wxCode
            //     //     }
            //     // };
            //     // params.url = "/sys/userinfo/list";
            //     // params.token = "swgykj9527";
            //     // params.success = function(res) {
            //        that.userName = that.xcxUser;
            //        that.getData();
            //     // };
            //     // this.ajaxPostWX(params);
            // },
            getData(){
                let params = {};
                var that = this;
                params.data = {
                    "username" : this.xcxUser,
                    "stat_month" : this.currentMonth.format("yyyy-MM")
                };
                params.url = "/sys/mealstat/statuser";
                params.token = "swgykj9527";
                params.success = function(res) {
//              	alert(JSON.stringify(res.data.result))
                   that.all = res.data.result;
                   that.showIt = res.data.result;
                };
                if(params.data.username){
                	this.ajaxPostWX(params);
                }
            }
        },
        mounted: function() {
            this.SET_LOADING("yes");
            var currentMonth = new Date();
            this.currentMonth = currentMonth;
//          this.getData();
        }
    }
</script>

<style lang="scss">
    .sp3{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100vh;
        font-size: 4vw;
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
        .leftName{
            line-height: 12vw;
            font-size: 4vw;
            height: 12vw;
            text-align: center;
            color: #706767;
        }
        .tabel{
            width: 100%;
            margin-top: 12vw;
            text-align: center;
            th,td{
                height: 12vw;
                color: #414141;
                font-size: 4vw;
                line-height: 12vw;
                border-bottom: 1px solid #414141;
            }
            th{
                font-size: 3vw;
                color: #b5b5b5;
                border-bottom: 1px solid #b5b5b5;
            }
        }
        .toHeight{
            height: 12vw;
            width: 100%;
            .ivu-input[disabled], fieldset[disabled] .ivu-input{
                height: 100%;
                font-size: 4vw;
            }
            .ivu-date-picker-rel{
                height: 100%;
                font-size: 4vw;
            }
            .ivu-input-icon-normal+.ivu-input,.ivu-input-wrapper{
                height: 100%;
                font-size: 4vw;
            }
            .ivu-icon-ios-calendar-outline:before{
                top: 6px;
                position: relative;
                font-size: 4vw;
            }
            .ivu-select-selection{
                height: 100%;
                .ivu-select-selected-value{
                    line-height: 12vw;
                    font-size: 4vw;
                    height: 12vw;
                }
            }
        }
        .topMon{
            color: #fff;
            font-size: 4vw;
            text-align: center;
            line-height: 14vw;
            .bigMoney{
                font-size: 12vw;
                line-height: 18vw;
                span{
                    font-size: 6vw;
                }
            }
        }
        .bgShow{
            height: 100%;
            width: 90%;
            padding-top: 10vw;
            margin: 0 auto;
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxStatistics.vue